
<div class="questionnaire-prompt">
    <div class="row text-center">
      <div class="col-sm-12">
      <h2 class="heading">We've found your info!</h2>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col-md-6 offset-md-3 text-center">
      <div class="text-copy">
        We've found the info you've previously submitted, but it doesn't look like you have a full account yet.
        Please reach out to us at <a textCta="light" href="mailto:{{ 'supportEmail' | branding | async }}">{{ 'supportEmail' | branding | async }}</a> or
        <a textCta="light" href="tel:215-607-8942">(215) 607-8942</a> to find out your next steps!
      </div>
      <br>
      <a class="btn btn-primary" [routerLink]="['/login']">Back to Login</a>
    </div>
  </div>
</div>
